import { AxnAdminUser } from "@idw-types/data/axn-admin-user";

export enum OrganizationUserDetailsActionTypes {
    // Organization User Details
    SET_ORGANIZATION_USER_DETAILS_LOADING = "SET_ORGANIZATION_USER_DETAILS_LOADING",
    SET_ORGANIZATION_USER_DETAILS = "SET_ORGANIZATION_USER_DETAILS"
}

// Organization User Details
type SetOrganizationUserDetailsLoadingAction = {
    type: OrganizationUserDetailsActionTypes.SET_ORGANIZATION_USER_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setOrganizationUserDetailsLoading = (isLoading: boolean): SetOrganizationUserDetailsLoadingAction => ({
    type: OrganizationUserDetailsActionTypes.SET_ORGANIZATION_USER_DETAILS_LOADING,
    payload: { isLoading }
});

type SetOrganizationUserDetailsAction = {
    type: OrganizationUserDetailsActionTypes.SET_ORGANIZATION_USER_DETAILS,
    payload: { axnAdminUser: AxnAdminUser; }
}

export const setOrganizationUserDetails = (axnAdminUser: AxnAdminUser): SetOrganizationUserDetailsAction => ({
    type: OrganizationUserDetailsActionTypes.SET_ORGANIZATION_USER_DETAILS,
    payload: { axnAdminUser }
});

export type OrganizationUserDetailsActions =
    // Organization User Details
    SetOrganizationUserDetailsLoadingAction |
    SetOrganizationUserDetailsAction